/**
 * Category seed data - flat taxonomy rows (CAT-03). Every row carries an empty
 * children array; the mock repository assembles the tree from parentId links.
 */
import { CategoryNodeState } from '@core/models/category.state';

/**
 * Roots surfaced in the shell subnav - the six deepest, best-stocked catalogs
 * so the strip fits on one row at desktop widths with no horizontal scroll.
 * Every other category stays reachable through the search category filter.
 */
const SUBNAV_ROOT_IDS = new Set([1, 2, 3, 4, 5, 7]);

const category = (id: number, slug: string, name: string, parentId: number | null): CategoryNodeState => ({
  id,
  slug,
  name,
  parentId,
  children: [],
  showInSubnav: SUBNAV_ROOT_IDS.has(id)
});

export const seedCategories = (): CategoryNodeState[] => [
  category(1, 'furniture', 'Furniture', null),
  category(2, 'clothing', 'Clothing', null),
  category(3, 'kitchen-dining', 'Kitchen & Dining', null),
  category(4, 'electronics', 'Electronics', null),
  category(5, 'sports', 'Sports', null),
  category(6, 'books-media', 'Books & Media', null),
  category(7, 'home-decor', 'Home Decor', null),
  category(8, 'music-records', 'Music & Records', null),
  category(9, 'toys-games', 'Toys & Games', null),
  category(10, 'jewelry-watches', 'Jewelry & Watches', null),
  category(11, 'dressers-storage', 'Dressers & Storage', 1),
  category(12, 'seating', 'Seating', 1),
  category(13, 'tables', 'Tables', 1),
  category(21, 'jackets-coats', 'Jackets & Coats', 2),
  category(22, 'denim', 'Denim', 2),
  category(41, 'cameras', 'Cameras', 4),
  category(42, 'audio', 'Audio', 4),
  category(51, 'hockey', 'Hockey', 5),
  category(52, 'cycling', 'Cycling', 5),
  category(53, 'winter-sports', 'Winter Sports', 5)
];
